import React from 'react';
import { Marker, InfoWindow } from '@react-google-maps/api';
import moment from 'moment';

var pinSVGFilled = "M 12,2 C 8.1340068,2 5,5.1340068 5,9 c 0,5.25 7,13 7,13 0,0 7,-7.75 7,-13 0,-3.8659932 -3.134007,-7 -7,-7 z";

const CustomMarker = (props) => {
    const [state, setState] = React.useState({
        showInfoWindow: false,
        stopHide: false,
        isActive: false
    })
    const timeoutRef = React.useRef()

    React.useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    React.useEffect(() => {
        if (props.activeMarker && props.activeMarker._id && props.activeMarker._id === props.jobsite._id) {
            setState({...state, isActive: true })
        }
    }, [props])
 
    const handleMouseOver = e => {
        setState(prevState => ({
            ...prevState,
            showInfoWindow: true
        }))
    };

    const handleMouseExit = e => {
        if (state.isActive && !props.hideInfoWindowOnActiveItem) {
            // Don't close if this is the active item
        } else {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        
            timeoutRef.current = setTimeout(() => {
                if (!state.stopHide) {
                    setState(prevState => ({
                        ...prevState,
                        showInfoWindow: false
                    }));
                }
            }, 2000);
        }
    };

    const handleInfoWindowMouseOver = e => {
        setState(prevState => ({
            ...prevState,
            showInfoWindow: true,
            stopHide: true
        }));
    }

    const handleInfoWindowMouseExit = e => {
        handleMouseExit();
    };

    const handleClick = (e) => {
        console.log('Click on this one!!', props)
        setState(prevState => ({
            ...prevState,
            showInfoWindow: true,
            stopHide: true
        }));
        props.updateActiveMarker(props.jobsite)
    }

    let ourPos = props.position
    if (!ourPos.lat || !ourPos.lng) {
       if (props?.jobsite?.location?.coordinates?.length) {
        ourPos.lat = props.jobsite.location.coordinates[1]
        ourPos.lng = props.jobsite.location.coordinates[0]
       }
    }

    if (ourPos && ourPos.lat && ourPos.lng) {
        const lat = Number(ourPos.lat)
        const lng = Number(ourPos.lng)
        let theColor = props.color
        if (props.jobsite && props.jobsite.color) theColor = props.jobsite.color
        let scale = 6
        let strokeColor = 'black'

        // Default marker icon
        let theIcon = {
            path: window.google.maps.SymbolPath.CIRCLE,
            scale: scale,
            fillColor: theColor,
            fillOpacity: 0.8,
            strokeWeight: 2,
            rotation: 0,
            strokeColor: strokeColor
        }

        // Enhanced marker for ordered sites (when a crew is selected)
        if (props.jobsite?.orderNumber && props.showOrderNumbers) {
            theIcon = {
                path: pinSVGFilled,
                anchor: new window.google.maps.Point(12, 17),
                fillOpacity: 1,
                fillColor: theColor,
                strokeWeight: 2,
                strokeColor: "white",
                scale: 1.5,
                labelOrigin: new window.google.maps.Point(12, 9),
            };
        }

        let clientName = (props.jobsite && props.jobsite.clientName) ? props.jobsite.clientName : 'CLIENT'
        let clientId = ''
        if (props.jobsite && props.jobsite.client) {
            clientId = props.jobsite.client
            if (props.jobsite.client._id) {
                clientId = props.jobsite.client._id
            }
        }

        let noCrewAssigned = true
        if (props.jobsite && props.jobsite.assignedCrew && props.jobsite.assignedCrew._id) noCrewAssigned = false
        if (props.jobsite && props.jobsite.crew && props.jobsite.crew._id) noCrewAssigned = false

        let activeMarkerId = props?.activeMarker?._id
        let jobSiteId = props?.jobsite?._id
        if (activeMarkerId === jobSiteId) theIcon = undefined

        let siteName = `${props.jobsite.name}`
        
        // Handle highlighted markers
        if (props?.highlightedSite === jobSiteId) {
            var markerImage = {
                path: pinSVGFilled,
                anchor: new window.google.maps.Point(12,17),
                fillOpacity: 1,
                fillColor: theColor,
                strokeWeight: 2,
                strokeColor: "white",
                scale: 2,
                labelOrigin: new window.google.maps.Point(12,9),
            };
            theIcon = markerImage
        }

        return (
            <Marker 
                position={{ lat, lng }} 
                icon={theIcon} 
                onClick={handleClick}
                onMouseOver={handleMouseOver}
                title={siteName}
                onMouseOut={handleMouseExit}
                label={props.jobsite?.orderNumber && props.showOrderNumbers ? {
                    text: props.jobsite.orderNumber.toString(),
                    color: "white",
                    fontSize: "12px",
                    fontWeight: "bold"
                } : undefined}
            >
                {/* InfoWindow can be added back if needed */}
            </Marker>
        );
    } else {
        console.log('invalid marker...', props)
        return null
    }
}

export default React.memo(CustomMarker)
